import React from 'react'

const CapsLockIcon = () => (
  <svg width="11" height="16" viewBox="0 0 11 16">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-834.000000, -566.000000)" stroke="#10CE64">
        <g transform="translate(817.000000, 558.000000)">
          <g transform="translate(18.000000, 9.000000)">
            <path
              d="M8.7509677,5.63298249 L5.2928427,0.445732493 C5.1489677,0.229732493 4.9307177,0.0798574928 4.6784677,0.0238574928 C4.2707177,-0.0651425072 3.8577177,0.0991074928 3.6265927,0.445732493 L0.168467704,5.63298249 C-0.036782296,5.94048249 -0.055782296,6.33435749 0.118592704,6.66060749 C0.293217704,6.98698249 0.631592704,7.18948249 1.0015927,7.18948249 L2.4548427,7.18948249 L2.4548427,10.4999825 C2.4548427,10.9134825 2.7913427,11.2499825 3.2048427,11.2499825 L5.7144677,11.2499825 C6.1279677,11.2499825 6.4644677,10.9134825 6.4644677,10.4999825 L6.4644677,7.18960749 L7.9178427,7.18960749 C8.2877177,7.18960749 8.6260927,6.98698249 8.8007177,6.66073249 C8.9752177,6.33435749 8.9562177,5.94048249 8.7509677,5.63298249 Z"
              id="Shape"
              strokeWidth="1.1"
              fillRule="nonzero"
            />
            <rect
              id="Rectangle"
              strokeWidth="1.5"
              x="2.85"
              y="14.25"
              width="3.225"
              height="1"
              rx="0.5"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default CapsLockIcon
